module.exports = __webpack_public_path__ + "media/step_2_da.d7ba2811.mp3";